"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 26. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Prices fetched from previous released releases.
 * @author Radek Beran
 */


var LastReleasedPrices =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(LastReleasedPrices, _DomainObject_1$Domai);

  /**
   * @param referencePrices last reference prices
   * @param finalPrices last final prices
   */
  function LastReleasedPrices(referencePrices, finalPrices) {
    var _this;

    _classCallCheck(this, LastReleasedPrices);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LastReleasedPrices).call(this));
    _this.referencePrices = referencePrices;
    _this.finalPrices = finalPrices;
    return _this;
  }

  return LastReleasedPrices;
}(DomainObject_1.DomainObject);

exports.LastReleasedPrices = LastReleasedPrices;